module.exports = __webpack_public_path__ + "img/integrador_de_dados_icon.5ec27901.svg";